import type { PostBreakdown } from "./kit";

export type ShoppingItem = {
  name: string;
  qty: number;
  price: number;
};

export const CABLE_ROLL_100_PRICE = 54.43;
export const CABLE_ROLL_400_PRICE = 217.73;

export const POST_PRICES = {
  levelEnd: 231.04,
  levelLine: 154.03,
  levelCorner: 268.84,
  angleEnd: 279.71,
  angleLine: 158.75,
} as const;

export function pickCableRolls(feet: number): { r100: number; r400: number } {
  if (feet <= 0) return { r100: 0, r400: 0 };
  let best = { r100: 0, r400: 0, cost: Infinity };
  const maxR400 = Math.ceil(feet / 400);
  for (let b = 0; b <= maxR400; b++) {
    const remaining = feet - b * 400;
    const a = remaining > 0 ? Math.ceil(remaining / 100) : 0;
    const cost = a * CABLE_ROLL_100_PRICE + b * CABLE_ROLL_400_PRICE;
    if (cost < best.cost) best = { r100: a, r400: b, cost };
  }
  return { r100: best.r100, r400: best.r400 };
}

export function buildShoppingItems(
  breakdown: PostBreakdown,
  cableFeet: number,
): ShoppingItem[] {
  const items: ShoppingItem[] = [
    { name: "Level End Post", qty: breakdown.levelEnd, price: POST_PRICES.levelEnd },
    { name: "Level Line Post", qty: breakdown.levelLine, price: POST_PRICES.levelLine },
    { name: "Level Corner Post", qty: breakdown.levelCorner, price: POST_PRICES.levelCorner },
    { name: "Angle End Post", qty: breakdown.angleEnd, price: POST_PRICES.angleEnd },
    { name: "Angle Line Post", qty: breakdown.angleLine, price: POST_PRICES.angleLine },
  ];

  const rolls = pickCableRolls(Math.ceil(cableFeet));
  if (rolls.r400 > 0) {
    items.push({
      name: '1/8" Cable (400ft roll)',
      qty: rolls.r400,
      price: CABLE_ROLL_400_PRICE,
    });
  }
  if (rolls.r100 > 0) {
    items.push({
      name: '1/8" Cable (100ft roll)',
      qty: rolls.r100,
      price: CABLE_ROLL_100_PRICE,
    });
  }
  return items;
}

export function shoppingTotals(items: ShoppingItem[]): { qty: number; price: number } {
  return {
    qty: items.reduce((s, i) => s + i.qty, 0),
    price: items.reduce((s, i) => s + i.qty * i.price, 0),
  };
}
